import { render, staticRenderFns } from "./LessonCard.vue?vue&type=template&id=4674afb4&"
import script from "./LessonCard.vue?vue&type=script&lang=js&"
export * from "./LessonCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports